module.exports = __webpack_public_path__ + "img/changeActivationType.71da8084.svg";